import { updateAppUrl } from 'lib/url/route'
import { urlQuery, slugifyPath } from 'lib/helpers'
import { getFirstFacetValue, removeUsedFacets } from './facets'

export const generateLocationUrl = ({
  queryParams,
  pathParams,
  sharedFacetNames,
  booleanFacetsObject = {},
}: Record<string, any>): string => {
  const urlPathParams = pathParams.reduce(
    (results, facetName) => ({
      ...results,
      [facetName]: getFirstFacetValue(facetName, queryParams[facetName], {
        sharedFacetNames,
        booleanFacetsObject,
      }),
    }),
    {}
  )

  // Product Note -> restore URL rules for /prints instead of /prints/all
  if (urlPathParams.has_prints && urlPathParams.category === 'All') {
    delete urlPathParams.category
  }

  const pathString = slugifyPath(
    Object.values(urlPathParams)
      .filter(Boolean)
      .map(String)
  )
  const queryCleanup = removeUsedFacets({
    facets: queryParams,
    usedValues: { ...urlPathParams, has_prints: true }, // Never append `has_prints` to `?` query
    pathParamBooleanFacetNameList: Object.keys(booleanFacetsObject) || [],
  })
  const queryString = urlQuery(queryCleanup)
  return `${pathString}${queryString}`
}

/*
  href: full path of the new page you want to navigate. Ex: /account/artworks/1979882?size=small
  VERY IMPORTANT TO NOT RELOAD ALL THE PAGE
  nextAppRoute: this is the nextJS app route logic, you need to check where is the page that is calling this function and get it's location from the "apps" folder.
  For instance, for the href example in this comment, it is the page artist all artworks that could have a path route like `/account/artworks/<userId>`, but the nextAppRoute is: `/user/artworks`
*/
export const updateClientSideUrl = (href: string, nextAppRoute: string): void => {
  updateAppUrl({
    app: nextAppRoute,
    href,
  })
}
